import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src={siteConfig.logo} 
              alt="CRN Logo" 
              className="h-12 md:h-14 w-auto object-contain transition-transform group-hover:scale-105"
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                location.pathname === '/' ? 'text-amber-600' : 'text-stone-600'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/opportunity" 
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                location.pathname === '/opportunity' ? 'text-amber-600' : 'text-stone-600'
              }`}
            >
              The Opportunity
            </Link>
            <a 
              href="https://crnnetwork.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm font-medium text-stone-600 transition-colors hover:text-amber-600"
            >
              CRN Network
            </a>
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 text-stone-600 hover:text-amber-600 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-stone-100">
            <nav className="flex flex-col gap-4">
              <Link 
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-base font-medium px-2 py-2 rounded-lg transition-colors ${
                  location.pathname === '/' ? 'text-amber-600 bg-amber-50' : 'text-stone-600 hover:bg-stone-50'
                }`}
              >
                Home
              </Link>
              <Link 
                to="/opportunity"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-base font-medium px-2 py-2 rounded-lg transition-colors ${
                  location.pathname === '/opportunity' ? 'text-amber-600 bg-amber-50' : 'text-stone-600 hover:bg-stone-50'
                }`}
              >
                The Opportunity
              </Link>
              <a 
                href="https://crnnetwork.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-base font-medium text-stone-600 px-2 py-2 rounded-lg hover:bg-stone-50 transition-colors"
              >
                CRN Network
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
